import { useAuth } from '../providers/AuthContext';

/**
 * Returns true when it's safe to make authenticated API calls.
 * During fresh login (isSignedIn=false, authLoading=true), returns false
 * to avoid 401s before the session cookie is established.
 * For return visits (isSignedIn=true from localStorage), returns true
 * immediately so data fetching isn't delayed.
 */
export function useCanFetch() {
  const { isSignedIn, loading } = useAuth();
  return isSignedIn || !loading;
}
